import css from './menu.module.scss';

export const MenuHr = () => <div className={css.hr} />;
